import * as consts from './GalleryConsts';
import { push } from 'react-router-redux';
import { savePosition } from '../app/AppActions';
import { getGalleryRequest } from '../helpers/requestUtils';


export const navigateToGallery = (element) => {
    return (dispatch, getState) => {
        dispatch(savePosition(element));
        dispatch(push(`/${getState().app.tourId}/${getState().app.tourType.charAt(0)}/gallery`));
    }
}

export const setActiveImage = (imageName) => {
    return {
        type: consts.SET_ACTIVE_IMAGE,
        payload: imageName
    }
}

export const showAllPhotos = () => {
    return { type: consts.SHOW_ALL_PHOTOS };
};

export const getGallery = () => {
    return (dispatch, getState) => {
        const tourId = getState().app.tourId;
        const tourType = getState().app.tourType;
        dispatch({ type: consts.GET_GALLERY_PENDING });
        getGalleryRequest(tourId, tourType).then(data => {
            if (data.Error.length) {
                dispatch({ type: consts.GET_GALLERY_REJECTED });
            } else {
                dispatch({
                    type: consts.GET_GALLERY_FULFILLED,
                    payload: {
                        gallery: data.data,
                        activeSlideName:  !!+data.data.images.length
                            ? data.data.images[0].file_name
                            : ''
                    }
                });
            }
        }, () => {
            dispatch({type: consts.GET_GALLERY_REJECTED});
        });
    }
}
